import getters from './getters'
import { actions as actions } from './actions'
import { mutations } from './mutations'
import moment from 'moment'

const state = {
  device: null,
  reservationDate: moment().format('DD/MM/YYYY'),
  reservationDateForServer: null,
  geoPosition: {},
  loader: false,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/global/index.js
// module id = null
// module chunks = 